module.exports = __webpack_public_path__ + "info-icon.bb0790a52e1340fa5ff7954cefd96495.svg";